export const HOME_ROUTES = {
  ForYou: { name: 'for-you', path: '/' },
  Keno: { name: 'keno', path: '/keno' },
  Lotteries: { name: 'lotteries', path: '/draw' },
  Scratchcards: { name: 'scratchcards', path: '/scratch' },
} as const
